import { PrinterOutlined } from '@ant-design/icons';
import { Button, ConfigProvider, Row, Typography, Form, Radio, Checkbox, Divider } from 'antd';
import React, { useState } from 'react';
import { Localization, _T } from '../../../../../base-react/src/Localization';
import { useParams } from 'react-router-dom';
import { hooks, models } from '@vote4dance/judging-sdk';
import { Loading } from '../../../../../base-react/components/Loading';
import { useCompetition } from '../../../../../base-react/hooks/Competition';
import dayjs from 'dayjs';
import { getAssetUrl } from '../../../../../base-react/scripts/cdn';
var Stream = hooks.streams.Stream;
var RoundTeamSource = models.teams.RoundTeamSource;
var HeatsTeamItem = models.teams.HeatsTeamItem;
var ClassItemSource = models.classes.ClassItemSource;
var ClassRoundSource = models.rounds.ClassRoundSource;
var RoundItem = models.rounds.RoundItem;
import { PrintStartNumberHeader } from './PrintStartNumber';
const { Title, Text } = Typography;
export const PrintDiploma = () => {
    const { competition_id, class_id, round_id } = useParams();
    const [inputCompetition, event, , loadingCompetition] = useCompetition(competition_id);
    const [teams, loadingTeams] = Stream(RoundTeamSource(round_id));
    const [classItem, loadingClasses] = Stream(ClassItemSource(competition_id, class_id));
    const [rounds, loadingRounds] = Stream(ClassRoundSource(class_id));
    const [settings, setSettings] = useState({
        styled: false,
        showCompetition: true,
        showStartNumbers: true
    });
    if (loadingCompetition || loadingTeams || loadingClasses || loadingRounds) {
        return React.createElement(Loading, null);
    }
    const foundRound = rounds && rounds.find((a) => a.round_id === round_id);
    if (!classItem || !foundRound) {
        return null;
    }
    // Flatten all team names with their corresponding teams
    const allDiplomas = teams
        ? teams
            .flatMap((team) => [team.team_name_1, team.team_name_2, team.team_name_3]
            .filter(Boolean) // Remove undefined or null names
            .map((name) => ({ team, name, isLast: false })) // Mark all as not last initially
        )
            // Filter away teams based on condition
            .filter(function ({ team }) {
            if (!RoundItem.isFinalRound(foundRound)) {
                return !team.heats_team_sent;
            }
            return true; // Keep the team if the condition doesn't apply
        }, this)
            // Sort by heats_team_placement
            .sort((a, b) => a.team.heats_team_placement - b.team.heats_team_placement)
        : [];
    // Mark the last item in the flattened list as `isLast`
    if (allDiplomas.length > 0) {
        allDiplomas[allDiplomas.length - 1].isLast = true;
    }
    return (React.createElement(ConfigProvider, null,
        React.createElement("style", { type: "text/css", media: "print" }, `@page { size: portrait; margin: 0 !important; color-adjust: exact !important; -webkit-print-color-adjust: exact !important; }`),
        React.createElement(PrintStartNumberSettings, { settings: settings, setSettings: setSettings }),
        React.createElement("div", null, allDiplomas.map(({ team, name, isLast }, index) => (React.createElement(PrintDiplomaTeam, { key: `${team.heats_team_id}-${index}`, team: team, classItem: classItem, round: foundRound, isLast: isLast, event: event, competition: inputCompetition, settings: settings }))))));
};
const PrintDiplomaTeam = (props) => {
    const { team, classItem, round, isLast, event, competition, settings } = props;
    let imageStyle = {
        height: '100%',
        margin: 12,
        backgroundSize: 'cover',
        backgroundImage: `url(${getAssetUrl(require('../../../../../screens-react/images/background.jpg'))})`
    };
    return (React.createElement("div", { style: settings.styled ? imageStyle : {} },
        React.createElement("div", { style: { padding: 12 } },
            React.createElement("div", { style: { padding: 12, height: 1070, backgroundColor: 'white', pageBreakAfter: isLast ? 'inherit' : 'always', textAlign: 'center' } },
                React.createElement(PrintStartNumberHeader, { event: event, competition: competition, settings: {
                        showCompetition: settings.styled && settings.showCompetition
                    } }),
                React.createElement(Row, { justify: 'center', style: { height: '220pt' } }, settings.styled &&
                    React.createElement(Typography, null,
                        React.createElement(Title, { level: 1, style: {
                                margin: 0,
                                fontSize: '80pt',
                                lineHeight: '220pt',
                                fontWeight: 800
                            } }, _T('print.diploma.title')))),
                settings.styled && React.createElement(Divider, null),
                React.createElement(Row, { justify: 'center', style: { marginTop: 100 } },
                    React.createElement(Typography, null,
                        React.createElement(Text, { style: { fontSize: '24pt', fontWeight: 600, margin: 4 } },
                            settings.showStartNumbers &&
                                React.createElement(React.Fragment, null, `${team.team_start_number} - `),
                            HeatsTeamItem.getFullName(team)))),
                React.createElement(Row, { justify: 'center' },
                    React.createElement(Typography, null,
                        React.createElement(Title, { level: 2, style: { margin: 4 } }, team.team_org_full ?
                            React.createElement(React.Fragment, null, team.team_org_full + (team.team_country ? (', ' + Localization.getCountryName(team.team_country)) : ''))
                            :
                                team.team_country && Localization.getCountryName(team.team_country)))),
                team.team_show_name &&
                    React.createElement(Row, { justify: 'center' },
                        React.createElement(Typography, null,
                            React.createElement(Title, { level: 2, style: { margin: 4 } }, team.team_show_name))),
                React.createElement(Row, { justify: 'center' },
                    React.createElement(Typography, null,
                        React.createElement(Title, { level: 1, style: { fontWeight: '100' } },
                            RoundItem.usesPlacement(round) && RoundItem.shouldShowPlacement(round, team.heats_team_placement) &&
                                React.createElement(React.Fragment, null,
                                    _T('print.diploma.place', { value: dayjs().localeData().ordinal(team.heats_team_placement).replace(/[\[\]]/g, '') }),
                                    " - "),
                            (classItem === null || classItem === void 0 ? void 0 : classItem.class_label) || (classItem === null || classItem === void 0 ? void 0 : classItem.class_name))))))));
};
const PrintStartNumberSettings = (props) => {
    const { settings, setSettings } = props;
    const onValuesChange = (values) => {
        setSettings({
            ...settings,
            ...values,
        });
    };
    const onFinish = () => {
        window.print();
    };
    return (React.createElement(Row, { style: { width: '100%', paddingLeft: 30, backgroundColor: 'lightgrey' } },
        React.createElement("div", { className: "settings" },
            React.createElement("style", null, `@media print {.settings{display: none;}}`),
            React.createElement(Title, null, _T('common.print', { name: _T('print.diploma.title').toLowerCase() })),
            React.createElement(Form, { name: "printsettings", labelCol: { span: 8 }, wrapperCol: { span: 16 }, style: { maxWidth: 600 }, initialValues: settings, onValuesChange: onValuesChange, onFinish: onFinish, autoComplete: "off" },
                React.createElement(Form.Item, { wrapperCol: { offset: 8, span: 16 } },
                    React.createElement(Form.Item, { name: "styled" },
                        React.createElement(Radio.Group, null,
                            React.createElement(Radio, { value: true }, _T('print.diploma.styled')),
                            React.createElement(Radio, { value: false }, _T('print.diploma.clean')))),
                    React.createElement(Form.Item, { name: "showCompetition", valuePropName: "checked", style: { marginBottom: 0 } },
                        React.createElement(Checkbox, null, _T('print.showCompetition'))),
                    React.createElement(Form.Item, { name: "showStartNumbers", valuePropName: "checked", style: { marginBottom: 0 } },
                        React.createElement(Checkbox, null, _T('print.showStartNumbers'))),
                    React.createElement(Button, { icon: React.createElement(PrinterOutlined, null), type: "primary", htmlType: "submit" }, _T('common.print')))))));
};
